import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../../../../core/components/modals/base-modal/base-modal.component";
import {MatButton} from "@angular/material/button";
import {DownloadPackagesExcelService} from "./services/download-packages-excel.service";
import {
  FileProgressBarStatusComponent
} from "../../../../../shared/components/ui/file-progress-bar-status/file-progress-bar-status.component";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {downloadPackagesExcelModalName} from "./configs/download-packages-excel-config";

@Component({
  selector: 'app-download-packages-excel-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    FileProgressBarStatusComponent,
    FormsModule,
    MatInputModule
  ],
  templateUrl: './download-packages-excel-modal.component.html',
  styleUrl: './download-packages-excel-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadPackagesExcelModalComponent extends BaseModalComponent {
  private downloadPackagesExcelService: DownloadPackagesExcelService = inject(DownloadPackagesExcelService);

  public fileName: string = 'packages';

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.modalStatesService.openModal(downloadPackagesExcelModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(downloadPackagesExcelModalName);
  }

  public async downloadPackagesExcel(): Promise<void> {
    if (!this.fileName) {
      this.errorService.showErrorMessage('Введите название файла');
      return;
    }

    const fileName = `${this.fileName}.xlsx`;
    await this.downloadPackagesExcelService.downloadPackagesExcel(fileName)
      .then(() => this.snackbarService.successShowMessage(`Файл ${fileName} успешно скачан`))
      .finally(() => this.closeDialog('cancel'));
  }
}
